var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha"},[_c('canvas',{ref:"captchaCanvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":_vm.refreshCaptcha}})])}
var staticRenderFns = []

export { render, staticRenderFns }